//export const URI =  'http://localhost:5000/';

//server droplet
export const URI =  '/';

const API_URL = {
   
    'POST_ADMIN_LOGIN': URI + 'api/adminuser/login',
    'POST_ADMIN_CREATE': URI + 'api/adminuser/create',
    'GET_ADMIN_ALL': URI + 'api/adminuser/',
    'DELETE_ADMIN': URI + 'api/adminuser/',


    'ADMIN_PRODUCT_SAVE': URI + 'api/product/save',
    'ADMIN_PRODUCT_ALL': URI + 'api/product/manage',
    'ADMIN_PRODUCT_BY_ID': URI + 'api/product/',
    'ADMIN_PRODUCT_APPROVAL': URI + 'api/product/approval/',
    'ADMIN_DELETE_PRODUCT': URI + 'api/product/delete/',

    // Product Export
    'ADMIN_PRODUCT_EXPORT': URI + 'api/product/',


    // AI Evaluations
    'ADMIN_EVAL_CASES': URI + 'api/admin/evals/cases',
    'ADMIN_EVAL_RUN': URI + 'api/admin/evals/run',
    'ADMIN_EVAL_RUNS': URI + 'api/admin/evals/runs',
    'ADMIN_EVAL_IMPORT': URI + 'api/admin/evals/import-defaults',

 }

Object.freeze(API_URL);

export default API_URL;
